<template>
<el-table-wrapper ref="sendMsgTable" :data="sendMsgDatas" :columns="tableColumn" fit-height header-align="center" :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange" :show-search-tool="showSearchTool"
  :show-custom-header="true" @selection-change="changeHandleSelection">
  <template #expand-col="props">
    <el-form :model="props.row" label-width="120px">
      <el-form-item label="보낸이">{{ props.row.senderName }} ({{ getDate(null, null, props.row.registDatetime) }})</el-form-item>
      <el-form-item label="받는사람">
        <div v-for="(target, index) in props.row.targetList" :key="target.managerId" style="display: inline;">
          <span>{{ target.managerName }}</span>
          [<span v-if="target.checkDatetime" style="color: green;">확인</span><span v-else style="color: gray;">미확인</span>]<span v-if="index < props.row.targetList.length-1">, </span>
        </div>
      </el-form-item>
      <el-form-item label="내용">
        <div v-html="props.row.messageContents"></div>
      </el-form-item>
      <el-form-item label="첨부파일">
        <span v-for="(file, index) in props.row.fileList" :key="index" style="margin-right: 5px; cursor: pointer;" @click="downloadFile(props.row.seqNumber, file)">
          <i class="far fa-file-download" style="margin-right: 2px;"></i>{{ file.attachFilename }}.{{ file.attachFiletype }}
        </span>
      </el-form-item>
    </el-form>
  </template>
  <template #messageContents-col="scope">
    <span class="c-pointer" @click="expandTrigger(scope.row)">
      <div v-html="scope.row.messageContents"></div>
    </span>
  </template>
  <template #file-col="scope">
    <i v-if="scope.row.fileList.length > 0" class="far fa-file-download"></i>
  </template>
</el-table-wrapper>
</template>

<script>
import userApi from '@/api/frame/user';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';

export default {
  name: 'WSendMessageTable',
  props: {
    showSearchTool: {
      type: Boolean,
      default: false,
    },
    currentActiveTab: {
      type: String,
    },
  },
  data() {
    return {
      sendMsgDatas: [],
      total: null,
      columnDefault,
      tableColumn: [
        {
          align: 'center',
          type: 'expand',
          scopedSlot: 'expand-col',
        },
        {
          align: 'center',
          type: 'selection',
          width: '50px',
        },
        {
          prop: 'messageContents',
          label: '내용',
          searchable: true,
          formatter: this.getTableMessageContents,
          remoteProp: 'message_contents',
          sortable: true,
          scopedSlot: 'messageContents-col',
        },
        {
          prop: 'registDatetime',
          label: '보낸시각',
          width: '150px',
          searchable: true,
          searchType: 'date',
          formatter: this.getDate,
          remoteProp: 'em.regist_datetime',
          sortable: true,
        },
      ],
      selectedMessage: [],
      params: {},
    };
  },
  watch: {
    currentActiveTab(val) {
      if (val === 'send') {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.sendMsgTable.getParameter();
      userApi.getSendMessageList(tableParams).then((response) => {
        if (response.data.success) {
          this.sendMsgDatas = response.data.data;
        }
      });
    },
    expandTrigger(row) { // 내용 클릭했을 경우에도 expand
      this.$refs.sendMsgTable.$children[0].toggleRowExpansion(row);
    },
    getDate(row, column, value) {
      return getDateToString(new Date(value));
    },
    changeHandleSelection(selectVal) {
      this.selectedMessage = selectVal;
    },
    downloadFile(seqNumber, file) {
      const params = {
        seqNumber,
        attachFilename: file.attachFilename,
      };
      userApi.downloadMessageFile(params);
    },
    deleteSendMessage() {
      if (this.selectedMessage.length > 0) {
        const action = msgUtil.action.DELETE;
        const target = '보낸 쪽지';
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          userApi
            .deleteSendMessage(this.selectedMessage)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.loadData();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        });
      } else {
        this.$message(msgUtil.getRequireMsgData('선택', '쪽지'));
      }
    },
    getMessageContents(messageContents) {
      return messageContents.split('\n').join('<br />');
    },
    getTableMessageContents(row, column, value) {
      return value.split('\n')[0];
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SendMessageTable.vue